// extracted by mini-css-extract-plugin
export default {"container-fluid":"Categories_container-fluid__MdMYW"};